var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('events-sheets-layout', {
    attrs: {
      "loading": _vm.loading
    },
    scopedSlots: _vm._u([{
      key: "body-items",
      fn: function fn() {
        return [_c('add-new-item-card', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.create-event-modal",
            modifiers: {
              "create-event-modal": true
            }
          }],
          attrs: {
            "variant": "primary-200"
          }
        }), _vm._l(_vm.events, function (event) {
          return _c('card', {
            key: event.id,
            attrs: {
              "item": event,
              "icons": ""
            },
            on: {
              "click": function click($event) {
                return _vm.onClick(event.id);
              },
              "delete-event": function deleteEvent($event) {
                return _vm.deleteEventOnClick(event.id);
              }
            }
          });
        }), _c('custom-modal', {
          attrs: {
            "id": "create-event-modal",
            "title": _vm.$t('dashboard.events.form.title')
          },
          scopedSlots: _vm._u([{
            key: "body",
            fn: function fn() {
              return [_c('create-event-modal', {
                on: {
                  "success": _vm.success,
                  "close": _vm.onClose
                }
              })];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }